import { css } from '@emotion/react';

import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('actionButtonGroup', [
  'column',
  'hiddenActionButton',
  'ghostVariant',
  'small',
]);

const getActionButtonGroupCss = css`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: var(--cds-spacing-100);

  &.${classes.column} {
    flex-direction: column;
    height: 100%;
    width: fit-content;
  }

  &.${classes.ghostVariant} {
    margin-left: calc(var(--cds-spacing-200) * -1);

    &.${classes.small} {
      margin-left: calc(var(--cds-spacing-100) * -1);
    }
  }

  .${classes.hiddenActionButton} {
    visibility: hidden;
    order: 1;
  }
`;

export default getActionButtonGroupCss;
